import { TemplateProperty } from '../../../../../lib/templates';

export const termsAndConditionTemplate: TemplateProperty = {
  name: 'termsAndConditions',
  type: { name: 'boolean' },
  label: 'Términos y condiciones',
  validators: [{ name: 'valid', signature: [true] }],
};
